import { BadRequest } from '@tsed/exceptions';
import type { GetServerSideProps, InferGetServerSidePropsType } from 'next';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import { getSelectorsByUserAgent } from 'react-device-detect';
import { getOnWheelBannerFn } from '@/api/cms/onwheel-banner/useGetOnWheelBanner';
import type { OnwheelPricing } from '@/api/cms/onwheel-pricing/types';
import { getOnwheelPricingFn } from '@/api/cms/onwheel-pricing/useGetOnwheelPricing';
import type {
  Banner,
  DefaultCmsDataResponse,
  DefaultCmsResponse,
} from '@/api/cms/types';
import { OnWheelPage } from '@/modules/service/cooperate/onwheel/OnWheelPage';
import { serviceConfig } from '@/modules/service/serviceConfig';

type Props = {
  // Declare OnWheel props
  isSsrMobile: boolean;
  onwheelPricingData: DefaultCmsDataResponse<OnwheelPricing> | null;
  onwheelBannerData: DefaultCmsDataResponse<Banner> | null;
};

export default function OnWheel(
  _props: InferGetServerSidePropsType<typeof getServerSideProps>
) {
  return (
    <OnWheelPage
      onwheelPricingData={_props.onwheelPricingData}
      onwheelBannerData={_props.onwheelBannerData}
    />
  );
}

export const getServerSideProps: GetServerSideProps<Props> = async (
  context
) => {
  const { locale } = context;
  if (locale == undefined) {
    throw new BadRequest('locale is missing');
  }
  const { i18nNamespaces } = serviceConfig;

  const { isMobile: isSsrMobile } = getSelectorsByUserAgent(
    context.req.headers['user-agent'] as string
  );

  let onwheelPricingRes = {} as DefaultCmsResponse<
    DefaultCmsDataResponse<OnwheelPricing>
  >;

  let onwheelBannerRes = {} as DefaultCmsResponse<
    DefaultCmsDataResponse<Banner>
  >;

  try {
    const res = await getOnWheelBannerFn();
    onwheelBannerRes = res;
  } catch (error) {
    console.log('OnWheelBanner', (error as Error).message);
  }

  try {
    const res = await getOnwheelPricingFn();
    onwheelPricingRes = res;
  } catch (error) {
    console.log(error);
  }

  return {
    props: {
      ...(await serverSideTranslations(locale, i18nNamespaces)),
      isSsrMobile,
      onwheelPricingData: onwheelPricingRes.data
        ? onwheelPricingRes.data
        : null,
      onwheelBannerData:
        onwheelBannerRes && onwheelBannerRes.data
          ? onwheelBannerRes.data
          : null,
    },
  };
};
